<template lang="html">
  <div class="contact">
    <div class="d-flex row justify-content-between">
      <div>
        <h1>{{$t('contato.pousada')}} Tranquilândia Village</h1>
        <h4>{{$t('contato.contato_localizacao')}}</h4>
      </div>
      <div class="d-flex flex-column align-items-center justify-content-center">
        <a class="test" target="_blank" href="https://www.tripadvisor.com.br/Hotel_Review-g635974-d1557902-Reviews-Pousada_Tranquilandia_Village-Canoa_Quebrada_State_of_Ceara.html">
          <img src="https://www.tripadvisor.com.br/img/cdsi/img2/badges/ollie-11424-2.gif" alt="TripAdvisor"/>
        </a>
        <p class="text-center">
          {{ $t('contato.tripadvisor.1') }} <br /> {{ $t('contato.tripadvisor.2') }}
        </p>
      </div>
    </div>
    <hr>

    <div class="row">
      <div class="col-md-6 col-lg-6 contato">
        <div class="contato-content">
          <p class="contact-img"><img src="../../assets/png/glyphicons-443-earphone.png" alt="Contato"></p>
          <hr>
          <a href="tel:+558834217012" class="remove-style-link">
            <p>+55 88 3421-7012</p>
          </a>
          <a target="_blank" href="https://api.whatsapp.com/send?phone=5588997416849&text=Oi%2C%20vim%20pelo%20site!%20Gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20reservas." class="remove-style-link">
            <p>+55 88 9 9741-6849 <img src="../../assets/png/whatsapp.png" alt="Whatsapp" style="height:20px"> </p>
          </a>
          <a href="mailto:tranquilandia@tranquilandia.it" class="remove-style-link">
            <p>tranquilandia@tranquilandia.it</p>
          </a>
          <a class="remove-style-link">
            <p>01.955.089/0001-02</p>
          </a>
        </div>
      </div>

      <div class="col-md-6 col-lg-6 localizacao">
        <div class="localizacao-content">
          <p class="contact-img"><img src="../../assets/png/glyphicons-243-map-marker.png" alt="Localização"></p>
          <hr>
          <a target="blank" class="remove-style-link" href="https://www.google.com/maps/place/4%C2%B031'29.5%22S+37%C2%B042'11.6%22W/@-4.5248657,-37.7037732,19z/data=!3m1!4b1!4m6!3m5!1s0x0:0x94964fec6c5ca07a!7e2!8m2!3d-4.5248668!4d-37.7032259">
            <p>Ceará - {{$t('contato.brasil')}}</p>
          </a>
          <a target="blank" class="remove-style-link" href="https://www.google.com/maps/place/4%C2%B031'29.5%22S+37%C2%B042'11.6%22W/@-4.5248657,-37.7037732,19z/data=!3m1!4b1!4m6!3m5!1s0x0:0x94964fec6c5ca07a!7e2!8m2!3d-4.5248668!4d-37.7032259">
            <p>Canoa Quebrada </p>
          </a>
          <a target="blank" class="remove-style-link" href="https://www.google.com/maps/place/4%C2%B031'29.5%22S+37%C2%B042'11.6%22W/@-4.5248657,-37.7037732,19z/data=!3m1!4b1!4m6!3m5!1s0x0:0x94964fec6c5ca07a!7e2!8m2!3d-4.5248668!4d-37.7032259">
            <p>{{$t('contato.rua')}} Oziel Pereira - 53</p>
          </a>
          <div class="card-contact-blank"></div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="links">
        <div class="facebook">
          <a href="https://www.facebook.com/Pousada-Tranquilandia-Village-143745388985847/" target="_blank">
            <img src="../../assets/png/facebook.png" alt="Facebook">
          </a>
        </div>
        <div class="instagram">
          <a href="https://www.instagram.com/pousadatranquilandiavillage/?hl=pt-br" target="_blank">
            <img src="../../assets/png/instagram.png" alt="Instagram">
          </a>
        </div>
        <div class="youtube">
          <a href="https://www.youtube.com/watch?v=ut5zSQ1wGss" target="_blank">
            <img src="../../assets/png/youtube.png" alt="Youtube">
          </a>
        </div>
        <div class="tripadvisor">
          <a href="https://www.tripadvisor.com.br/Hotel_Review-g635974-d1557902-Reviews-Pousada_Tranquilandia_Village-Canoa_Quebrada_State_of_Ceara.html" target="_blank">
            <img src="../../assets/png/tripadvisor1.png" alt="TripAdvisor">
          </a>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="copyright">
        <p>© {{ year }} <a href="https://launchertech.com/" target="_blank">LauncherTech</a></p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>

<style lang="css">
@import url('https://fonts.googleapis.com/css?family=Quicksand');

div.contact {
  background-color: #FFFFFF;
  font-family: 'Quicksand', sans-serif;
  padding: 50px;
  /* border-top: 3px solid rgb(118, 106, 49); */
  border-top: 1px solid #ccc;
}

div.contact .contato,
div.contact .localizacao {
  padding: 20px;
}
div.contact div.contato-content,
div.contact div.localizacao-content {
  padding: 20px;
  border: 1px solid #888;
  border-radius: 10px;
  transition: box-shadow 1s;
  cursor: pointer;

}
div.contact div.contato-content .remove-style-link,
div.contact div.localizacao-content .remove-style-link {
  text-decoration: none;
  color: black;
}
div.contact div.contato-content:HOVER,
div.contact div.localizacao-content:HOVER {
  box-shadow: 3px 3px 3px #777;
}

div.contact div.contato-content p.contact-img,
div.contact div.localizacao-content p.contact-img {
  text-align: center;
}
div.contact div.contato-content p.contact-img {
  margin-bottom: 21px;
}
div.contact div.contato-content p.contact-img img,
div.contact div.localizacao-content p.contact-img img {
  width: 25px;
}

div.contact div.links {
  display: flex;
  width: 100%;
  margin-top: 20px;
  align-items: center;
  justify-content: center;
}
div.contact div.links .facebook,
div.contact div.links .instagram,
div.contact div.links .youtube,
div.contact div.links .tripadvisor {
  max-width: 50%; /* Centralizar */
}
div.contact div.links .tripadvisor {
  margin-left: 8px;
}
div.contact div.links .facebook img,
div.contact div.links .instagram img,
div.contact div.links .youtube img,
div.contact div.links .tripadvisor img {
  width: 40px;
  transition: filter 1s;
}
div.contact div.links .tripadvisor img {
  filter: brightness(30%);
  transition: filter 1s;
}
div.contact div.links .facebook img:HOVER,
div.contact div.links .instagram img:HOVER,
div.contact div.links .youtube img:HOVER,
div.contact div.links .tripadvisor img:HOVER {
  filter: saturate(20);
}
div.contact div.links .tripadvisor img:HOVER {
  filter: saturate(3);
}

div.contact div.row div.copyright {
  width: 100%;
  margin-top: 50px;
}
div.contact div.row div.copyright p {
  text-align: center;
  color: #007bff
}
div.contact div.row div.copyright p a {
  color: #007bff
}

.card-contact-blank {
  display: block;
  height: 2.5rem;
  margin: 0;
  padding: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/contact/Contact.vue